import { DateFormat } from "sr/helpers/functions/DateFormat";
import { DateFormatWithTime } from "sr/helpers/functions/DateFormatWithTime";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";

export const TableRow = ({item, setShowDelete, setDeleteId}) => {
   const transactionStatus = [
      {label:'Completed', value:'completed'},
      {label:'Pending', value:'pending'}
   ]
  return (
    <tr className="bg-white border-b  hover:bg-gray-50">
      
 <td className="px-6 py-4">                

          ${Number(item?.amount)?.toFixed(2)}

        </td>
        <td className="px-6 py-4">
<div>
   {getLabelByValue(item?.status, transactionStatus)}
</div>
        </td>
        <td className="px-6 py-4">
{DateFormatWithTime(item?.createdAt)}
        </td>


        <td className="px-6 py-4">
         <div onClick={()=> {setShowDelete(true); setDeleteId(item?.batch_id)}} className="py-1.5 px-2 w-fit cursor-pointer hover:text-[#a9252b]   hover:border-2 hover:rounded-lg box-border border-2 border-neural-200 rounded-lg  hover:border-[#f76266] hover:bg-[#FEEEEF]">
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-8 h-6 text-black cursor-pointer hover:text-[#f76266]"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg>
 </div>
  </td>
    </tr>
     );
};
